module.exports = __webpack_public_path__ + "img/OEVO-Logo.3acdc56b.png";